// import routes from '@/modules/reservation/reservation-routes';
import store from '@/modules/reservation/reservation-store';

export default {
  // routes,
  store,
};
